import "../elements/Spinner/spinner.css";

import AsyncBudgeaHandler from "../components/Payment/BudgeaHandler/BudgeaHandler";
import Dash from "../containers/Dash/Dash";
import Loadable from "react-loadable";
//import Pages from '../containers/Pages/Pages.jsx';
import React from "react";
import Spinner from "../elements/Spinner/Spinner";

// import asyncComponent from '../components/AsyncComponent';
// TODO: next is using react-loadable
// https://serverless-stack.com/chapters/code-splitting-in-create-react-app.html

let LoadableSpinner = () => <Spinner size="lg" fullScreen />;

// const AsyncDash = Loadable({
//   loader: () =>
//     import('../containers/Dash/Dash' /* webpackChunkName: "chunk-dash" */),
//   loading: LoadableSpinner,
//   modules: ['chunk-dash']
// });
const AsyncCompanies = Loadable({
  loader: () =>
    import("../views/Companies" /* webpackChunkName: "chunk-companies" */),
  loading: LoadableSpinner,
  modules: ["chunk-companies"]
});

// const AsyncPlans = Loadable({
//   loader: () => import("../containers/Plans/PlansContainer"),
//   loading: LoadableSpinner,
//   modules: ["chunk-plans"]
// });

const AsyncOnboardingWizard = Loadable({
  loader: () =>
    import("../components/onboarding/Wizard" /* webpackChunkName: "chunk-wizard" */),
  loading: LoadableSpinner,
  modules: ["chunk-wizard"]
});

// const AsyncBudgeaHandler = Loadable({
//   loader: () =>
//     import("../components/Payment/BudgeaHandler/BudgeaHandler" /* webpackChunkName: "chunk-budgea" */),
//   loading: LoadableSpinner,
//   modules: ["chunk-budgea"]
// });

// const AsyncDash = asyncComponent(() => import("../containers/Dash/Dash"));
// const AsyncCompanies = asyncComponent(() => import("../views/Companies"));
// const AsyncOnboardingWizard = asyncComponent(() => import("../components/onboarding/Wizard"));

/*
import Dash from '../containers/Dash/Dash.jsx';
import Companies from '../views/Companies';
import OnboardingWizard from "../components/onboarding/Wizard";
*/
//import ProfilePage from '../views/ProfilePage'

var appRoutes = [
  /*
  { path: "/companies", name: "Companies", component: Companies },
  { path: "/onboarding", name: "Onboarding", component: OnboardingWizard },
  { path: "/", name: "Home", component: Dash }
  */

  { path: "/companies", name: "Companies", component: AsyncCompanies },
  // { path: "/plans", name: "Plans", component: AsyncPlans },
  { path: "/onboarding", name: "Onboarding", component: AsyncOnboardingWizard },
  { path: "/budgea", name: "Budgea", component: AsyncBudgeaHandler },
  { path: "/", name: "Home", component: Dash }

  //    { path: "/profile", name: "Profile", component: ProfilePage },
];

// { path: "/pages/login-page", name: "Pages", component: Pages },
// { path: "/pages/register-page", name: "Pages", component: Pages },
// { path: "/pages/lock-screen-page", name: "Pages", component: Pages },

export default appRoutes;
